





























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import VoteList from '../components/VoteList.vue';
import Detail from '../components/DetailModal.vue';
import { Popup } from 'vant';
import * as config from '../config';
import DetailModal from '../components/DetailModal.vue';
import SuccessModal from '../components/SuccessModal.vue';
import BottomTabbar from '../components/BottomTabbar.vue';
import Rule from '../components/Rule.vue';
import Music from '../components/Music.vue';
Vue.use(Popup);
@Component({
  components: {
    VoteList,
    Detail,
    DetailModal,
    SuccessModal,
    BottomTabbar,
    Rule,
    Music,
  },
})
export default class First extends Vue {
  @Prop() successStatus!: any;
  option = config.OPTHINES;
  guide = true;
  show: boolean = true;
  Status = false;
  closeGuide() {
    this.guide = false;
  }
  showPopup() {
    this.show = true;
  }
  toggleModal2() {
    this.show = false;
  }
  selectNum(data: number) {
    this.$emit('selectNum', data);
  }

  @Watch('successStatus', {
    immediate: true,
  })
  changeSsuccessStatus() {
    if (this.successStatus) {
      this.Status = true;
    }
  }
}
